module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAAAAXNSR0IArs4c6QAAAKlJREFUOBGdUtsRgCAMQz8dxaX036VcylH0F4sKYo/UttxBHzS5RAwxxpX2ELyLwGlttEcXxwW/j53CbCapCHJqs5RRLOotMWBd6izVCJDLlgCIt7ElPinUbUsCAF19LaGpn36x1KVB889zAw4KS+8EZ1gMP1LRdbHgIXB/xPSMU9ZeItLI+q/kgnwSNtgqv5INBG3JSgIsWUEgSxYIdJIBgV5yg8AmmRGcU6LNDZf/eK0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/search/triangle.png
// module id = 707
// module chunks = 1